import type { ReactNode } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DashboardPeriodPreset } from '@inversor-hub/types';
import { PageHeader } from '@/components/ui/PageHeader.tsx';

interface DashboardHeaderProps {
  title: string;
  period?: DashboardPeriodPreset;
  periodLabel?: string;
  onPeriodChange?: (period: DashboardPeriodPreset) => void;
  isPeriodLoading?: boolean;
  action?: ReactNode;
}

const periodOptions: { value: DashboardPeriodPreset; label: string }[] = [
  { value: 'YTD', label: 'Este año' },
  { value: '6M', label: 'Últimos 6 meses' },
  { value: '12M', label: 'Últimos 12 meses' },
  { value: '24M', label: 'Últimos 24 meses' },
];

export function DashboardHeader({
  title,
  period,
  periodLabel,
  onPeriodChange,
  isPeriodLoading = false,
  action,
}: DashboardHeaderProps) {
  const periodSelector = period && periodLabel && onPeriodChange && (
    <Box sx={{ minWidth: { xs: '100%', sm: 220 } }}>
      <FormControl fullWidth size="small">
        <InputLabel id="dashboard-period-label">Periodo de los gráficos</InputLabel>
        <Select
          labelId="dashboard-period-label"
          value={period}
          label="Periodo de los gráficos"
          disabled={isPeriodLoading}
          startAdornment={<CalendarTodayIcon sx={{ mr: 1, color: 'text.secondary' }} />}
          onChange={(event) => onPeriodChange(event.target.value as DashboardPeriodPreset)}
        >
          {periodOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
        {periodLabel}
      </Typography>
    </Box>
  );

  return (
    <PageHeader
      title={title}
      action={
        (action || periodSelector) && (
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems={{ xs: 'stretch', md: 'flex-start' }}
            spacing={1.5}
          >
            {action}
            {periodSelector}
          </Stack>
        )
      }
    />
  );
}
